
import { validUsername } from '@/utils/validate'
import { doSms, qrLogin } from '@/api/user'
import { setToken } from '@/utils/auth'
import {  mapMutations } from 'vuex'
import config from '@/config'
import { getToken } from '@/utils/auth'

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入短信验证码'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      vailcheck: false,
      isTen: true,
      setTime: null,
      headerValue: '',
      isActive: 0,
      actImg: '',
      loginForm: {
        sms_key: '',
        mobile: '',
        sms_code: ''
      },
      timer: null,
      isCode: false,
      txtCode: '获取验证码',
      loginRules: {
        mobile: [{ required: true, trigger: 'blur', validator: validateUsername }],
        sms_code: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      loading: false,
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    },
    '$store.state.user.showLoginDialog': {
      handler: function(val) {
          if (val) {
            this.dialogVisible = true
          }
      },
      deep: true
    },
    isActive:  {
      handler: function (val) {
          if ( val == 0 && this.dialogVisible) {
              if (this.setTime) {
                clearInterval(this.setTime)
                this.setTime = null
              }
              this.setTime = setInterval( () => {
                  qrLogin({scene: this.headerValue}).then( res => {
                      // this.SET_TOKEN(res.data.token)
                      if (res.data.token) {
                        this.$store.commit('user/SET_SNC_TOKEN',res.data.token)
                        this.hidePop()
                        // this.$store.dispatch('user/getInfo')
                        clearInterval(this.setTime)
                        this.setTime = null
                      }

                  })

              }, 3000)

          }
      },
      immediate: true
    }
  },

  // this.$refs.loginComp.hidePop()
  methods: {
    ...mapMutations(['HIDE_LOGIN_DIALOG']),
    async showPop() {
        this.dialogVisible = true
        // const res = await miniproGramCode({})
        fetch(`${config.SSR_API_URL}passport/miniprogramCode`)
        .then(async (response) => {
          // 获取 header 值
          const headerValue = response.headers.get('x-scene');
          // debugger
          this.headerValue = headerValue
          const bloc = await response.blob()
          this.actImg = URL.createObjectURL(bloc)
        })

        if (this.setTime) {
          clearInterval(this.setTime)
          this.setTime = null
        }
        if ( this.isActive == 0 && this.dialogVisible ) {
            this.setTime = setInterval( () => {
                qrLogin({scene: this.headerValue}).then( res => {
                  if (res.data.token) {
                    this.$store.commit('user/SET_SNC_TOKEN',res.data.token)
                    this.$store.dispatch('user/getInfo')
                    this.hidePop()
                  }

                })

            }, 1500)

        }
    },
    hidePop() {
        this.dialogVisible = false
        this.$store.commit('user/HIDE_LOGIN_DIALOG')
        if (this.setTime) {
          clearInterval(this.setTime)
          this.setTime = null
        }
        if (this.$route.query.isLogin) {
          window.location.href = `https://bbs.zgszcy.com/${getToken()}`
        }
    },
    isMobile:  function(value) {
			return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      return /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
		},
    async getCode() {
        if (this.isCode) {
          return false
        }
        if (!this.loginForm.mobile || !this.isMobile(this.loginForm.mobile)) {
          return this.$toasted.error('请输入完整手机号',{position: "top-center", duration: 2000})
        }

        const res = await doSms({mobile: this.loginForm.mobile})
        this.loginForm.sms_key = res.data.sms_key
        let time = 60
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
        this.timer = setInterval( () => {
          if (time <= 0) {
            this.txtCode = '获取验证码'
            this.isCode = false
            clearInterval(this.timer)
            this.timer = null
          }
          this.isCode = true
          this.txtCode = time + '秒后重新获取'
          time--
        }, 1000)
    },

    handleLogin() {
      if (!this.vailcheck) {
          return this.$toasted.error('请同意用户协议',{position: "top-center", duration: 2000})
      }
      if (!this.loginForm.sms_key) {
          return this.$toasted.error('请获取短信验证码',{position: "top-center", duration: 2000})
      }
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          clearInterval(this.timer)
          this.$store.dispatch('user/login', this.loginForm).then((data) => {
            this.loading = false
            if (this.isTen) {
              // 14天免登录
              setToken(data.token)
            }
            this.$store.dispatch('user/getInfo')
            this.$emit('logined')
            this.hidePop()

          }).catch((err) => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
